<script lang="ts">
	import type { SbImage, SbLink } from '../types';
	import Image from '../components/image.svelte';
	import SbRichtext from '../components/sbRichtext.svelte';
	import { getSbUrl } from '$lib/utils/storyblok/url';
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';

	interface Props {
		content: ISbStoryData<{
			image?: SbImage;
			asset?: ISbStoryData['content'][];
			title: string;
			text: string | ISbRichtext;
			link: SbLink;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<div use:editable={content} class="overflow-hidden rounded-2xl bg-stone-4 text-brown-2">
	<a href={getSbUrl(content.link)} target={content.link.target}>
		{#if content.asset && content.asset.length > 0}
			<div class="aspect-4/3 h-full w-full lg:aspect-square">
				<Blok content={content.asset[0]} />
			</div>
		{:else if content.image}
			<Image
				class="aspect-4/3 h-full w-full object-cover lg:aspect-square"
				src={content.image.filename}
				title={content.image.title ?? ''}
				alt={content.image.alt ?? ''}
				width={750}
				sizes={{ 768: { width: 1580 }, 1024: { width: 600 } }}
			/>
		{/if}
		<div class="px-4 py-5 lg:px-5 lg:py-6">
			<p class="line-clamp-1 text-[20px]/[110%] font-semibold">
				{content.title}
			</p>
			{#if content.text}
				<div class="mt-2 line-clamp-2 text-[14px]/[140%] lg:text-[16px]">
					<SbRichtext text={content.text} />
				</div>
			{/if}
		</div>
	</a>
</div>
